import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from './../../service/user.service';
import { NotificationService } from 'src/app/services/notification.service';
import { ActionMessage, TypeMessage } from 'src/app/entity/enum/enum-notification';

@Component({
  selector: 'app-list-users',
  templateUrl: './list-users.component.html',
  styleUrls: ['./list-users.component.scss']
})
export class ListUsersComponent implements OnInit {
  listUser = []
  adm: boolean = false;

  constructor(private service: UserService, private router: Router, private notificationService: NotificationService) { }

  ngOnInit(): void {

    this.getUserPermission()

  }

  getUserPermission = async () => {
    await this.service.userIsAdmin().subscribe(adm => {
      if (adm) {
        this.adm = true;
        this.getList()
      }

    })
  }
  getList() {
    this.service.getListUser()
      .then(res => {
        this.listUser = res.data;
      })
      .catch(err => {
        console.error(err);
      })
  }
  newUser() {
    this.router.navigateByUrl('adm/users/new')
  }
  edit(id) {
    this.router.navigateByUrl('adm/users/edit/' + id)
  }
  deleteUser(id) {
    this.service.deleteUserById(id)
      .then(res => {
        this.notificationService.sendNotification(
          null,
          TypeMessage.Delete,
          ActionMessage.Success
        );
        this.getList()
      })
      .catch(err => {
        console.error(err);
      })
  }
}
